import '../stylesheets/companies';
import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

$(function () {
  // 株主優待画像
  $('.slick-imagedots .slick-wrapper .slick').each(function () {
    const slider = $(this);
    slider.slick({
      arrows: true,
      prevArrow: slider.siblings('.prev'),
      nextArrow: slider.siblings('.next'),
    });
    const dot = slider.parents('.slick-wrapper').siblings('.slick-selector').find('figure');
    $(window).on('load', function() {
      setCurrent(0);
    });
    slider.on('afterChange', function(slick, currentSlide) {
      setCurrent(currentSlide['currentSlide'] );
    });
    dot.on('click', function() {
      const index = $(this).index();
      slider.slick('slickGoTo', index, false);
      setCurrent(index);
    });
    function setCurrent(index) {
      dot.removeClass('current');
      dot.eq(index).addClass('current');
    }
  });

  // ピックアップ
  $('.stock-group .slick.stocks').each(function () {
    $(this).slick({
      infinite: false,
      variableWidth: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      prevArrow: $(this).siblings('.prev'),
      nextArrow: $(this).siblings('.next'),
    });
  });
});
